module.exports = __webpack_public_path__ + "static/media/b-arts-major-9_LR.006a8542.jpg";